import { IWhiteLabel, WHITELABEL_NAME } from 'lib/api/whitelabel/getWhiteLabel';
import { THEME_NAME } from '../auth/types';
import { IUserData } from 'lib/api/users/getUser';
import { RESELLER_IDS } from 'lib/const';
import { DefaultTheme } from 'styled-components/macro';

const BLACK = '#000000';
export const getThemeByWhiteLabel = (
  whitelabel: IWhiteLabel | undefined,
  user?: IUserData
) => {
  if (user?.resellerId?.toString() === RESELLER_IDS.CDK) {
    return THEME_NAME.CDK;
  }
  if (!whitelabel) {
    return THEME_NAME.BRANDING;
  }
  if (whitelabel.name === WHITELABEL_NAME.COVIDEO) {
    return THEME_NAME.BRANDING;
  }

  return improveWhiteLabelName(whitelabel.name);
};

export const improveWhiteLabelName = (name: WHITELABEL_NAME) => {
  switch (name) {
    case WHITELABEL_NAME.KENNECTED:
      return THEME_NAME.KENNECTED;
    case WHITELABEL_NAME.PRO_VIDEO_NOW:
      return THEME_NAME.PROVIDEO;
    case WHITELABEL_NAME.APP_2_VID:
      return THEME_NAME.APP_2_VID;
    case WHITELABEL_NAME.CDK:
      return THEME_NAME.CDK;
    default:
      return THEME_NAME.COVIDEO;
  }
};

type SecondaryLevel = 5 | 10 | 20 | 40 | 60 | 80 | 100 | 'non_alpha';

function toRgbTuple(color: string): [number, number, number] {
  const trimmed = color.trim();

  // Handle rgb/rgba formats using regex
  if (trimmed.startsWith('rgb')) {
    const match = trimmed.match(/\d+/g);
    if (!match || match.length < 3) {
      throw new Error(`Invalid rgb/rgba format: ${color}`);
    }
    return [Number(match[0]), Number(match[1]), Number(match[2])];
  }

  // Handle hex formats (#RGB, #RRGGBB, #RRGGBBAA)
  if (trimmed.startsWith('#')) {
    let hex = trimmed.slice(1);

    // Expand shorthand hex (#RGB -> #RRGGBB)
    if (hex.length === 3 || hex.length === 4) {
      hex = hex
        .split('')
        .map(char => char + char)
        .join('')
        .slice(0, 6);
    }

    // Remove alpha if present (#RRGGBBAA -> #RRGGBB)
    if (hex.length === 8) {
      hex = hex.slice(0, 6);
    }

    if (hex.length !== 6) {
      throw new Error(`Invalid hex format: ${color}`);
    }

    return [
      parseInt(hex.slice(0, 2), 16),
      parseInt(hex.slice(2, 4), 16),
      parseInt(hex.slice(4, 6), 16),
    ];
  }

  throw new Error(`Unsupported color format: ${color}`);
}

export function getSecondaryColor(
  theme: DefaultTheme,
  level: SecondaryLevel = 100
): string {
  const secondary = theme?.colors?.secondary;
  if (!secondary) {
    return BLACK;
  }

  // If level is non_alpha, return it directly
  if (level === 'non_alpha') {
    return secondary.non_alpha || BLACK;
  }

  // Check if text.color exists and derive from it
  const baseColor = secondary.text?.color;
  if (baseColor) {
    try {
      const [r, g, b] = toRgbTuple(baseColor);
      return `rgba(${r}, ${g}, ${b}, ${level / 100})`;
    } catch {
      return secondary[level] || BLACK;
    }
  }

  return secondary[level] || BLACK;
}
